import clsx from 'clsx'
import type { ReactNode } from 'react'

export const CallOutList = ({
  children,
  className,
  alternateSectionDirection = true,
}: {
  children: ReactNode
  className?: string
  alternateSectionDirection?: boolean
}) => {
  return (
    <div
      className={clsx([
        'callout-list',
        alternateSectionDirection ? '' : 'dont-alternate',
        className,
      ])}
    >
      {children}
    </div>
  )
}

export const CallOutItem = ({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) => {
  return <div className={clsx(['callout', className])}>{children}</div>
}

export const CallOutText = ({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) => {
  return <div className={clsx(['callout-text', className])}>{children}</div>
}

export const CallOutIllustration = ({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) => {
  return (
    <div className={clsx(['callout-illustration', className])}>{children}</div>
  )
}
